module.exports = __webpack_public_path__ + "img/130-australia.149012c1.svg";